import { Component, Input, EventEmitter, Output } from '@angular/core';
import { StateOfCarService } from '@app/shared/services/state-of-car.service';
import { DateService } from '@app/shared/services/date.service';
import { PhotoService } from '@app/shared/services/photo.service';
declare var UIkit: any;

@Component({
    selector: 'app-manager-state-of-car-informations',
    templateUrl: './manager-state-of-car-informations.component.html',
    styleUrls: ['./manager-state-of-car-informations.component.scss']
})
export class ManagerStateOfCarInformationsComponent {

    public managerState: any = {};
    public managerStates: any = [];
    public loading: boolean = true;
    public loadingPhoto: boolean = false;

    @Input() id: number = 0;
    @Input() relatedStates: any = [];
    @Output() changed = new EventEmitter();

    constructor(
        private stateOfCarService: StateOfCarService,
        private dateService: DateService,
        private photoService: PhotoService
    ) { }

    ngOnChanges() {
        if (this.id !== 0) {
            this.loading = true;
            this.stateOfCarService.getManagerStateOfCarById(this.id).then((res) => {
                res = this.dateService.convertToLocal(res);
                this.managerState = res;
                this.sortStates();
                this.loading = false;
            });
        }
    }

    sortStates() {
        if (this.relatedStates.length === 0) {
            return;
        }
        let sorted = false;
        let expectedStates = this.relatedStates.length + 1;
        let part = 1;

        this.managerStates = [];
        while (sorted === false) {
            if (this.managerState.part === part) {
                this.managerStates.push(this.managerState);
                part += 1;
            }
            this.relatedStates.forEach((related) => {
                if (related.part === part) {
                    this.managerStates.push(related);
                    part += 1;
                }
            });
            if (this.managerStates.length === expectedStates) {
                sorted = true;
            }
        }
    }

    modifyPhoto(selectedState) {
        let state: any = {
            id_manager_state_car: selectedState.idStateOfCar,
            title: selectedState.title,
            comment: selectedState.comment,
            state: selectedState.state
        };

        this.photoService.askFile().then((photo) => {
            this.loadingPhoto = true;
            state.photo = photo;
            this.stateOfCarService.updateManagerStateOfCar(state).then((res) => {
                this.stateOfCarService.getManagerStateOfCarById(selectedState.idStateOfCar).then((res) => {
                    if (this.relatedStates.length > 0) {
                        let index = this.managerStates.indexOf(selectedState);
                        this.managerStates[index] = res;
                    } else {
                        this.managerState = res;
                    }
                    this.loadingPhoto = false;
                });
            });
        });
    }

    updateState() {
        let state: any = {
            id_manager_state_car: this.managerState.idStateOfCar,
            title: this.managerState.title,
            comment: this.managerState.comment,
            state: this.managerState.state
        };

        if (this.relatedStates.length > 0) {
            let promises: Array<any> = [];

            this.managerStates.forEach((manager) => {
                state.id_manager_state_car = manager.idStateOfCar;
                promises.push(this.stateOfCarService.updateManagerStateOfCar(state));
            });
            Promise.all(promises).then(() => {
                this.changed.emit();
                UIkit.modal('#manager-state-of-car-informations').hide();
            });
        } else {
            this.stateOfCarService.updateManagerStateOfCar(state).then((res) => {
                this.changed.emit();
                UIkit.modal('#manager-state-of-car-informations').hide();
            });
        }
    }

}
